import styled from "styled-components";

export const InfoRowContainer = styled.div`
    width: 100%;
    height: 70px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
`

export const DetailRowContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 1rem;
`